import { Button } from "@blueprintjs/core"
import classNames from "classnames"
import { History } from "lucide-react"

type PastStopsSwitchProps = {
  checked: boolean
  /** True when the route has no current order to show stops for. */
  disabled?: boolean
  onCheckedChange: (checked: boolean) => void
  /** Placement; the default is the old fixed spot for maps without a column */
  className?: string
}

const PastStopsSwitch = ({
  checked,
  disabled = false,
  onCheckedChange,
  className = "absolute left-[10px] top-[185px] z-10",
}: PastStopsSwitchProps) => {
  // The toggle can be stored on while the room has no order: a disabled
  // switch must not look active then.
  const active = checked && !disabled
  const title = disabled
    ? "No order on this route"
    : checked
      ? "Hide completed stops"
      : "Show completed stops"

  return (
    <div className={className}>
      <Button
        id="toggle-past-stops"
        active={active}
        disabled={disabled}
        className={classNames(
          "!h-[30px] !min-h-[30px] !w-[30px] !min-w-[30px] !p-0 dark:text-white",
          active
            ? "!bg-[#1565c0] !text-white hover:!bg-[#11519a] dark:!bg-[#1565c0]"
            : "!text-[#5f6b7c] hover:!text-[#5f6b7c] dark:bg-gray-700 dark:!text-white",
        )}
        icon={<History size={16} strokeWidth={2.25} />}
        onClick={() => onCheckedChange(!checked)}
        title={title}
      />
    </div>
  )
}

export default PastStopsSwitch
